{
  "$id": "wealthlane://forms/department/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "department_fields",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/name",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 300,
          "maxWidthPx": 600
        },
        {
          "scope": "#/properties/description",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 300,
          "maxWidthPx": 600,
          "rows": 4
        }
      ]
    }
  ]
}
